import React from 'react';

/**
 * Inline card-brand strip displayed on every payment surface so customers
 * know what's accepted BEFORE they pull out their wallet. Explicitly calls
 * out that American Express is NOT supported (Stares Group merchant
 * account doesn't carry Amex). Brand list comes from /api/inspyre/config
 * so it stays in sync with the merchant account configuration.
 */

// SVG brand marks bundled inline (small, no external requests).
const BRAND_MARKS = {
  visa: {
    label: 'Visa',
    svg: (
      <svg viewBox="0 0 48 32" width="48" height="32" aria-hidden="true">
        <rect width="48" height="32" rx="4" fill="#1A1F71" />
        <text x="24" y="22" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontWeight="900" fontSize="14" fontStyle="italic">VISA</text>
      </svg>
    ),
  },
  mastercard: {
    label: 'Mastercard',
    svg: (
      <svg viewBox="0 0 48 32" width="48" height="32" aria-hidden="true">
        <rect width="48" height="32" rx="4" fill="#fff" stroke="#e2e8f0" />
        <circle cx="20" cy="16" r="9" fill="#EB001B" />
        <circle cx="28" cy="16" r="9" fill="#F79E1B" fillOpacity="0.9" />
      </svg>
    ),
  },
  discover: {
    label: 'Discover',
    svg: (
      <svg viewBox="0 0 48 32" width="48" height="32" aria-hidden="true">
        <rect width="48" height="32" rx="4" fill="#fff" stroke="#e2e8f0" />
        <text x="24" y="20" textAnchor="middle" fill="#222" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="9">DISCOVER</text>
        <circle cx="35" cy="20" r="3" fill="#FF6000" />
      </svg>
    ),
  },
};

const CardBrandStrip = ({ brands, compact = false }) => {
  const list = (brands || ['visa', 'mastercard', 'discover'])
    .map((b) => b.trim().toLowerCase())
    .filter((b) => BRAND_MARKS[b]);

  return (
    <div
      data-testid="card-brand-strip"
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: compact ? 6 : 10,
        marginTop: compact ? 6 : 10,
      }}
    >
      <span style={{ fontSize: compact ? 11 : 12, color: '#64748b', fontWeight: 600, marginRight: 4 }}>
        We accept:
      </span>
      {list.map((b) => (
        <span key={b} title={BRAND_MARKS[b].label} aria-label={BRAND_MARKS[b].label}>
          {BRAND_MARKS[b].svg}
        </span>
      ))}
      <span
        data-testid="no-amex-notice"
        style={{
          fontSize: compact ? 10 : 11,
          color: '#7c2d12',
          background: '#fef3c7',
          border: '1px solid #fcd34d',
          padding: '2px 8px',
          borderRadius: 999,
          fontWeight: 700,
          letterSpacing: 0.3,
          marginLeft: 4,
        }}
      >
        American Express not accepted
      </span>
    </div>
  );
};

export default CardBrandStrip;
